export const BUSINESS_EQUITY_SUMMARY_PROPORTION_CHART_BUSINESS_VALUE_COLOR =
  '#FF144F';
export const BUSINESS_EQUITY_SUMMARY_PROPORTION_CHART_BUSINESS_DEBT_COLOR =
  '#B20A45';
